import './Showcase.scss'
import React, { useRef, useState } from 'react'
import Button from '../Button/Button'

import rdvstoreDesktop from '../../assets/work/rdvstore-desktop.webp'
import rdvstoreTablet from '../../assets/work/rdvstore-tablet.webp'
import rdvstoreMobile from '../../assets/work/rdvstore-mobile.webp'
import oeilbrunDesktop from '../../assets/work/oeilbrun-desktop.webp'
import oeilbrunTablet from '../../assets/work/oeilbrun-tablet.webp'
import oeilbrunMobile from '../../assets/work/oeilbrun-mobile.webp'
import sdvDesktop from '../../assets/work/sdv-desktop.webp'
import sdvTablet from '../../assets/work/sdv-tablet.webp'
import sdvMobile from '../../assets/work/sdv-mobile.webp'
import cldbDesktop from '../../assets/work/cldb-desktop.webp'
import cldbTablet from '../../assets/work/cldb-tablet.webp'
import cldbMobile from '../../assets/work/cldb-mobile.webp'
import bauDesktop from '../../assets/work/bau-desktop.webp'
import bauTablet from '../../assets/work/bau-tablet.webp'
import bauMobile from '../../assets/work/bau-mobile.webp'

const projects = [
    {
        id: 'rendez-vous-store',
        name: 'Rendez-Vous Store',
        category: 'Boutique en ligne · Mode & design',
        text: 'Boutique multi-marques sous WooCommerce, avec un thème sur mesure et des extensions développées pour les besoins de la boutique.',
        features: [
            <><strong>Thème WordPress sur mesure</strong>, bilingue : accueil, designers, journal…</>,
            <><strong>Tunnel d’achat repensé</strong> : un parcours clair et fluide, de la fiche produit au paiement</>,
            <><strong>Développement de plugins WordPress sur mesure</strong>, adaptés aux besoins spécifiques du client</>,
            <><strong>Outil personnalisé de statistiques de ventes</strong> par période, marque et catégorie</>,
        ],
        images: { desktop: rdvstoreDesktop, tablet: rdvstoreTablet, mobile: rdvstoreMobile },
        href: 'https://rendez-vous-store.com',
    },
    {
        id: 'oeil-brun',
        name: 'Cie L’Œil Brun',
        category: 'Compagnie de théâtre',
        text: 'Le site de la compagnie : spectacles, équipe, films et livres de ses artistes. Tout est géré par la compagnie elle-même depuis un back-office sur mesure.',
        features: [
            <><strong>Fiches spectacles complètes</strong> : distribution, production, revue de presse, liens, résidences</>,
            <><strong>Calendrier des dates</strong> avec ajout en un clic à Google Agenda</>,
            <><strong>Newsletter générée</strong> depuis le back-office et transmise à Brevo, prête à l’envoi</>,
            <><strong>Biographies, films et livres</strong> des artistes, avec liens de vente et vidéos</>,
            <><strong>Spectacles à la une</strong> de l’accueil, choisis en autonomie</>,
        ],
        images: { desktop: oeilbrunDesktop, tablet: oeilbrunTablet, mobile: oeilbrunMobile },
        status: 'Mise en ligne prochainement',
    },
    {
        id: 'souffleur-de-verre',
        name: 'Cie Souffleur de Verre',
        category: 'Compagnie de théâtre',
        text: 'Un site vitrine dynamique avec back-office personnalisé, permettant à la compagnie de gérer elle-même ses spectacles, ses actualités et ses contenus.',
        features: [
            <><strong>Spectacles</strong> : dates de représentation, résidences et galeries photo en autonomie</>,
            <><strong>Calendrier des actualités</strong> par saison, avec ajout à Google Agenda</>,
            <><strong>Newsletter générée</strong> depuis le back-office et transmise à Brevo</>,
            <><strong>Équipe, biographies et logos</strong> des partenaires modifiables</>,
            <><strong>Sauvegarde automatique</strong> des données chaque nuit</>,
        ],
        images: { desktop: sdvDesktop, tablet: sdvTablet, mobile: sdvMobile },
        href: 'https://www.souffleurdeverre.fr',
    },
    {
        id: 'clement-dubois',
        name: 'Clément Dubois',
        category: 'Portfolio d’un scénographe',
        text: 'Un site visuel pensé pour mettre en valeur une pratique artistique et des projets scéniques, avec une navigation simple et une forte identité graphique.',
        features: [
            <><strong>Projets</strong> avec texte et galerie d’images réordonnable par glisser-déposer</>,
            <><strong>Visionneuse plein écran</strong> pour parcourir les images d’un projet</>,
            <><strong>Page « Infos »</strong> modifiable par l’artiste lui-même</>,
            <><strong>Adresse propre par projet</strong> et plan du site généré automatiquement pour le référencement</>,
        ],
        images: { desktop: cldbDesktop, tablet: cldbTablet, mobile: cldbMobile },
        href: 'https://www.clement-dubois.com',
    },
    {
        id: 'bau',
        name: 'BAU — Amata Zdziobeck',
        category: 'Architecture & urbanisme',
        text: 'Un site pensé comme un espace immersif de présentation de projets, avec une interface inspirée d’un cabinet de curiosités : maquettes, plans, croquis et réalisations.',
        features: [
            <><strong>Back-office complet</strong> : projets avec croquis légendés, dessins et articles</>,
            <><strong>Accueil et « à propos »</strong> éditables bloc par bloc : étapes, FAQ, réassurance</>,
            <><strong>Galeries</strong> réordonnables par glisser-déposer</>,
            <><strong>Interface en cabinet de curiosités</strong>, avec transitions de pages animées</>,
        ],
        images: { desktop: bauDesktop, tablet: bauTablet, mobile: bauMobile },
        status: 'En cours de développement',
    },
]

function Showcase() {
    const [selected, setSelected] = useState(0)
    const tabRefs = useRef([])
    const project = projects[selected]

    const select = (index, focus = false) => {
        const next = (index + projects.length) % projects.length

        setSelected(next)
        if (focus && tabRefs.current[next]) {
            tabRefs.current[next].focus()
        }
    }

    // arrow keys move through the list, as on any tab list
    const onKeyDown = (event) => {
        const keys = {
            ArrowDown: selected + 1,
            ArrowRight: selected + 1,
            ArrowUp: selected - 1,
            ArrowLeft: selected - 1,
            Home: 0,
            End: projects.length - 1,
        }

        if (event.key in keys) {
            event.preventDefault()
            select(keys[event.key], true)
        }
    }

    return (
        <section
            id="realisations"
            className="showcase"
            aria-labelledby="showcase-title"
        >
            <div className="showcase__container">
                <div className="showcase__nav">
                    <h2 id="showcase-title" className="showcase__title">
                        Quelques réalisations
                    </h2>

                    <ul
                        className="showcase__list"
                        role="tablist"
                        aria-label="Choisir un projet"
                        onKeyDown={onKeyDown}
                    >
                        {projects.map((item, index) => (
                            <li key={item.id} role="presentation">
                                <button
                                    ref={(el) => { tabRefs.current[index] = el }}
                                    type="button"
                                    role="tab"
                                    id={`showcase-tab-${item.id}`}
                                    aria-selected={index === selected}
                                    aria-controls="showcase-panel"
                                    tabIndex={index === selected ? 0 : -1}
                                    className={`showcase__tab${index === selected ? ' is-selected' : ''}`}
                                    onClick={() => select(index)}
                                >
                                    <span className="showcase__tab-number">
                                        {String(index + 1).padStart(2, '0')}
                                    </span>
                                    <span className="showcase__tab-text">
                                        <span className="showcase__tab-name">{item.name}</span>
                                        <span className="showcase__tab-category">{item.category}</span>
                                    </span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                <div
                    id="showcase-panel"
                    role="tabpanel"
                    aria-labelledby={`showcase-tab-${project.id}`}
                    className="showcase__stage"
                >
                    <div key={project.id} className="showcase__swap">
                        <div className="showcase__visual">
                            <img
                                className="showcase__image showcase__image--desktop"
                                src={project.images.desktop}
                                alt={`Vue desktop du site ${project.name}`}
                            />
                            <img
                                className="showcase__image showcase__image--tablet"
                                src={project.images.tablet}
                                alt={`Vue tablette du site ${project.name}`}
                            />
                            <img
                                className="showcase__image showcase__image--mobile"
                                src={project.images.mobile}
                                alt={`Vue mobile du site ${project.name}`}
                            />
                        </div>

                        <div className="showcase__details">
                            <div className="showcase__summary">
                                <p className="showcase__category">{project.category}</p>
                                <h3 className="showcase__name">{project.name}</h3>
                                <p className="showcase__text">{project.text}</p>

                                <div className="showcase__action">
                                    {project.href ? (
                                        <Button
                                            type="link"
                                            variant="lightButton"
                                            href={project.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            ariaLabel={`Voir le site ${project.name}, s’ouvre dans un nouvel onglet`}
                                        >
                                            Voir le site
                                        </Button>
                                    ) : (
                                        <span className="showcase__status">{project.status}</span>
                                    )}
                                </div>
                            </div>

                            <ul className="showcase__features" aria-label="Fonctionnalités principales">
                                {project.features.map((feature, i) => (
                                    <li key={i}>
                                        <span>{feature}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Showcase
